var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"accordion"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/clarencelifts.stagingwebsite.dev/web/app/themes/clarence-lifts/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/clarencelifts.stagingwebsite.dev/web/app/themes/clarence-lifts/node_modules/vue-loader/lib?{}!./scripts/vue/AccordionWrapper.vue?vue&type=template&id=f0d63aa8&scoped=true&
// module id = 203
// module chunks = 0